angular.module('impactx.event').directive('ixScrollDetection', function ($parse) {
    return {
        restrict: 'A',
        link: postLink
    };

    function postLink(scope, element, attrs) {
        element.bind('scroll', function () {
            scope.$applyAsync(function () {
                var scrollFunction = $parse(attrs.ixScrollDetection);
                if (scrollFunction) {
                    scrollFunction(scope, {$event: event, scrollTop: element.scrollTop()});
                }
                else {
                    element.unbind('scroll');
                }
            });
        });
    }
});